import { cn } from "@/lib/styles.utils";

const Title = ({ title, className }: { title: string; className?: string }) => {
  return (
    <h1
      data-testid="title-modal"
      className={cn("font-ib-bold text-xl", className)}
    >
      {title}
    </h1>
  );
};

export default Title;
